import React from 'react';
import CompanyProfileForm from '../../components/CompanyAdmin/CompanyProfileForm';

const CompanyProfilePage = () => {
  return (
    <>
      
      <CompanyProfileForm />
    </>
  );
};

export default CompanyProfilePage;
